import { appConfig } from "@/config/app";
import { pageMetadata } from "@/config/seo";
import { usePageMeta } from "@/features/marketing/usePageMeta";
import { Hero } from "@/features/marketing/sections/Hero";
import { ThreadBand } from "@/features/marketing/sections/ThreadBand";
import { HowItWorks } from "@/features/marketing/sections/HowItWorks";
import { LateNotice } from "@/features/marketing/sections/LateNotice";
import { Connections } from "@/features/marketing/sections/Connections";
import { ForFirms } from "@/features/marketing/sections/ForFirms";
import { PricingTeaser } from "@/features/marketing/sections/PricingTeaser";
import { FAQ } from "@/features/marketing/sections/FAQ";
import { FounderNote } from "@/features/marketing/sections/FounderNote";
import { FinalCTA } from "@/features/marketing/sections/FinalCTA";

export function LandingPage() {
  const meta = pageMetadata("/", appConfig.name, appConfig.domain);
  usePageMeta(meta.title, meta.description, "/");

  return (
    <>
      <Hero />
      <ThreadBand />
      <HowItWorks />
      <Connections />
      <LateNotice />
      <ForFirms />
      <PricingTeaser />
      <FAQ />
      <FounderNote />
      <FinalCTA />
    </>
  );
}
